import React, { useState } from 'react';
import { MdOutlineCleaningServices } from 'react-icons/md';

import classes from '../../assign/Assign.module.css';
import classesGlobal from '../../../assets/Global.module.css';
import Button from '../../../assets/essentials/Button';
import Select from '../../../assets/essentials/Select';
import OptionList from '../../../helpers/options/OptionList';
import PostForm from '../../../api/internal/PostForm';
import TextArea from '../../../assets/essentials/TextArea';
import Form from '../../../assets/essentials/Form';

function Customer({
  customerId,
  data,
  RefreshPage,
}: {
  customerId: Number;
  data: CustomerCommodities;
  RefreshPage: Function;
}) {
  const [isOpen, setIsOpen] = useState(false);
  function AssignCommodity(e) {
    e.preventDefault();
    const formData = new FormData(e.target);
    PostForm(`/Customer/CreateCustomerCommodity`, formData, {
      customerId: customerId,
    })
      .then(() => RefreshPage('Summary', ['Audit']))
      .catch(error => {
        const errorMessage = error.response.data;
        if (errorMessage.includes('already exists')) {
          alert(error.response.data);
        }
      });
    setIsOpen(false);
  }

  return (
    <>
      <div className={classes.btnHolder}>
        <button type="button" onClick={() => setIsOpen(!isOpen)}>
          <MdOutlineCleaningServices />
          <span>Assign Commodity</span>
        </button>
      </div>
      <div className={`${classes.expandable} ${classes.commodity}`}>
        {isOpen && (
          <Form onSubmit={e => AssignCommodity(e)}>
            <div
              className={`${classesGlobal.attribute} ${classesGlobal.span3}`}
            >
              <label>
                Commodity <span className={classesGlobal.required}>*</span>
              </label>
              <Select required defaultValue="" name="commodityId">
                <option disabled value="">
                  -- Required --
                </option>
                <OptionList
                  optionData={data.customerCommodityOptions}
                  attributeID="commodityId"
                  attributeName="type"
                  attributeGroup="group"
                ></OptionList>
              </Select>
            </div>
            <div
              className={`${classesGlobal.attribute} ${classesGlobal.span3}`}
            >
              <label>Note</label>
              <TextArea type="text" name="note" />
            </div>

            <div>
              <Button type="submit" variant="good" disabled={true}>
                Submit
              </Button>
            </div>
            <div>
              <Button onClick={() => setIsOpen(!isOpen)}>Cancel</Button>
            </div>
          </Form>
        )}
      </div>
    </>
  );
}

export default Customer;
